import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { DocumentLookup } from "../lookup";
import { TEXTS } from "../../constants";
import {
  NavWrapper,
  NavLayoutWrapper,
  NavLeft,
  NavRight,
  NavButton,
  BackIcon,
  DocumentIcon,
  LoginIcon,
} from "./Navigation.styles.jsx";

function Navigation({
  showBack = false,
  showDocuments = true,
  showHome = true,
  transparent = false,
  onBack,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLookupOpen, setIsLookupOpen] = useState(false);

  const isHomePage = location.pathname === "/";

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (window.history.length <= 1) {
      // Opened in a new tab (e.g. admin view link) – go to dashboard
      navigate("/company/contracts");
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <NavWrapper $transparent={transparent}>
        <NavLayoutWrapper>
          <NavLeft>
            {/* Back Button */}
            {showBack && !isHomePage && (
              <NavButton onClick={handleBack}>
                <BackIcon style={{ transform: "rotate(180deg)" }} />
                <span>{TEXTS.COMMON.BACK}</span>
              </NavButton>
            )}

            {/* Home Button Removed */}

            {/* Login Button - Only on Home Page */}
            {isHomePage && (
              <NavButton onClick={() => navigate("/company/login")}>
                <LoginIcon />
                <span>התחברות</span>
              </NavButton>
            )}
          </NavLeft>

          <NavRight>
            {/* My Documents Button */}
            {showDocuments && (
              <NavButton $primary onClick={() => setIsLookupOpen(true)}>
                <DocumentIcon />
                <span>{TEXTS.NAV.MY_DOCUMENTS}</span>
              </NavButton>
            )}
          </NavRight>
        </NavLayoutWrapper>
      </NavWrapper>

      {/* Document Lookup Modal */}
      <DocumentLookup
        isOpen={isLookupOpen}
        onClose={() => setIsLookupOpen(false)}
      />
    </>
  );
}

export default Navigation;
